import React, { useState, useEffect } from 'react';
import { Table, Modal, Button, Form, Badge, Card, ListGroup, Dropdown } from 'react-bootstrap';
import {
    FaSortAmountUp,
    FaSortAmountDown,
    FaPhone,
    FaEye,
    FaFilter,
    FaArrowLeft,
    FaArrowRight,
    FaEnvelope,
    FaMoneyBillWave,
    FaCheckCircle,
    FaSyncAlt,
    FaUserCheck,
    FaFlagCheckered,
    FaComment,
    FaPlus,
    FaGraduationCap,
    FaUserClock,
    FaEye as FaEyeIcon,
    FaCheck,
    FaFileExport,
    FaFileInvoiceDollar,
    FaTag,
    FaSave,
    FaCalendarAlt,
    FaBuilding,
    FaMoneyBill,
    FaClock,
    FaUsersCog,
    FaRobot,
    FaUser,
    FaPercentage,
    FaExclamationCircle,
    FaTrash
} from 'react-icons/fa';
import Sidebar from '../../dashboard/sidebar';
import Navbar from '../../dashboard/navbar';
import { Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import Select from 'react-select';
import InscriptionModal from './inscription';

// Données fictives mises à jour avec les nouveaux champs
const mockData = [
    {
        id: 1,
        nom: "Dupont",
        prenoms: "Jean",
        telephone: "0123456789",
        email: "jean.dupont@gmail.com",
        profession: "Ingénieur",
        diplome: "Master",
        type_financement: "Entreprise",
        date_inscription: "2024-01-10",
        date_appel: "2024-01-15",
        date_relance: "2024-01-22",
        montant_facture: "2000 FCFA",
        discount: "10%",
        montant_a_payer: "1800 FCFA",
        montant_paye: "500 FCFA",
        reste_a_payer: "1300 FCFA",
        acomptes: [
            { id: 1, date: "2024-01-16", montant: "500 FCFA", type: "Acompte" }
        ],
        acompte: true,
        solde_complet: false,
        montant_acompte: "500 FCFA",
        etape: "Prospection",
        commentaires: [
            { id: 1, texte: "Premier contact téléphonique. Intéressé par la formation PMP.", date: "2024-01-15 10:30", auteur: "Admin" },
            { id: 2, texte: "A envoyé son CV et diplômes. En attente de validation.", date: "2024-01-16 14:20", auteur: "Admin" }
        ],
        dernier_commentaire: { id: 2, texte: "A envoyé son CV et diplômes. En attente de validation.", date: "2024-01-16 14:20", auteur: "Admin" }
    },
    {
        id: 2,
        nom: "Martin",
        prenoms: "Marie",
        telephone: "0987654321",
        email: "marie.martin@gmail.com",
        profession: "Chef de projet",
        diplome: "Licence",
        type_financement: "Personnel",
        date_inscription: "2024-01-05",
        date_appel: "2024-01-10",
        date_relance: "2024-01-17",
        montant_facture: "1500 FCFA",
        discount: "0%",
        montant_a_payer: "1500 FCFA",
        montant_paye: "1500 FCFA",
        reste_a_payer: "0 FCFA",
        acomptes: [
            { id: 1, date: "2024-01-11", montant: "750 FCFA", type: "Acompte" },
            { id: 2, date: "2024-01-12", montant: "750 FCFA", type: "Solde" }
        ],
        acompte: false,
        solde_complet: true,
        montant_acompte: null,
        etape: "Clôture",
        commentaires: [
            { id: 1, texte: "Inscription confirmée. Attente paiement.", date: "2024-01-10 09:15", auteur: "Admin" },
            { id: 2, texte: "Paiement reçu en totalité. Formation confirmée.", date: "2024-01-12 16:45", auteur: "Admin" }
        ],
        dernier_commentaire: { id: 2, texte: "Paiement reçu en totalité. Formation confirmée.", date: "2024-01-12 16:45", auteur: "Admin" }
    },
    {
        id: 3,
        nom: "Bernard",
        prenoms: "Pierre",
        telephone: "0654321987",
        email: "pierre.bernard@gmail.com",
        profession: "Consultant",
        diplome: "Doctorat",
        type_financement: "Entreprise",
        date_inscription: "2024-01-08",
        date_appel: "2024-01-12",
        date_relance: "2024-01-19",
        montant_facture: "2500 FCFA",
        discount: "15%",
        montant_a_payer: "2125 FCFA",
        montant_paye: "1000 FCFA",
        reste_a_payer: "1125 FCFA",
        acomptes: [
            { id: 1, date: "2024-01-13", montant: "1000 FCFA", type: "Acompte" }
        ],
        acompte: true,
        solde_complet: false,
        montant_acompte: "1000 FCFA",
        etape: "Onboarding",
        commentaires: [
            { id: 1, texte: "Dossier complet reçu.", date: "2024-01-12 11:00", auteur: "Admin" },
            { id: 2, texte: "Acompte reçu. Accès plateforme envoyé.", date: "2024-01-13 15:30", auteur: "Admin" }
        ],
        dernier_commentaire: { id: 2, texte: "Acompte reçu. Accès plateforme envoyé.", date: "2024-01-13 15:30", auteur: "Admin" }
    },
    {
        id: 4,
        nom: "Petit",
        prenoms: "Sophie",
        telephone: "0765432198",
        email: "sophie.petit@gmail.com",
        profession: "Directrice",
        diplome: "MBA",
        type_financement: "Personnel",
        date_inscription: "2024-01-14",
        date_appel: null,
        date_relance: null,
        montant_facture: "1800 FCFA",
        discount: "5%",
        montant_a_payer: "1710 FCFA",
        montant_paye: "0 FCFA",
        reste_a_payer: "1710 FCFA",
        acomptes: [],
        acompte: false,
        solde_complet: false,
        montant_acompte: null,
        etape: "Prospection",
        commentaires: [],
        dernier_commentaire: null
    },
    {
        id: 5,
        nom: "Durand",
        prenoms: "Luc",
        telephone: "0234567891",
        email: "luc.durand@gmail.com",
        profession: "Architecte",
        diplome: "Master",
        type_financement: "Entreprise",
        date_inscription: "2024-01-11",
        date_appel: "2024-01-14",
        date_relance: "2024-01-21",
        montant_facture: "2200 FCFA",
        discount: "0%",
        montant_a_payer: "2200 FCFA",
        montant_paye: "300 FCFA",
        reste_a_payer: "1900 FCFA",
        acomptes: [
            { id: 1, date: "2024-01-15", montant: "300 FCFA", type: "Acompte" }
        ],
        acompte: true,
        solde_complet: false,
        montant_acompte: "300 FCFA",
        etape: "Facturation",
        commentaires: [
            { id: 1, texte: "Demande de devis envoyée.", date: "2024-01-14 14:00", auteur: "Admin" },
            { id: 2, texte: "Acompte de 300 FCFA reçu. Solde à régler.", date: "2024-01-15 10:15", auteur: "Admin" }
        ],
        dernier_commentaire: { id: 2, texte: "Acompte de 300 FCFA reçu. Solde à régler.", date: "2024-01-15 10:15", auteur: "Admin" }
    }
];

// Options pour les étapes
const ETAPES = [
    { value: "Annulee", label: "Annulee", icon: <FaSyncAlt className="mr-1 text-primary" /> },
    { value: "Prospection", label: "Prospection", icon: <FaSyncAlt className="mr-1 text-primary" /> },
    { value: "Facturation", label: "Facturation", icon: <FaMoneyBillWave className="mr-1 text-primary" /> },
    { value: "Onboarding", label: "Onboarding", icon: <FaUserCheck className="mr-1 text-primary" /> },
    { value: "Clôture", label: "Clôture", icon: <FaFlagCheckered className="mr-1 text-primary" /> },
    { value: "Archive", label: "Archivé", icon: <FaFlagCheckered className="mr-1 text-primary" /> }
];

const ListeInscriptions = ({ titre }) => {
    useAuth();
    const [inscriptions, setInscriptions] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedInscription, setSelectedInscription] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'descending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [newComment, setNewComment] = useState('');
    const [nouveauAcompte, setNouveauAcompte] = useState('');
    const [nouveauDiscount, setNouveauDiscount] = useState('');

    // Pour le développement, on utilise les données fictives
    const [useMockData, setUseMockData] = useState(false);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [paginationInfo, setPaginationInfo] = useState({
        current_page: 1,
        total_pages: 1,
        total_items: 0,
        items_per_page: 10,
        has_next: false,
        has_previous: false
    });

    const user_id = localStorage.getItem('user_id');

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Inscriptions";
        }
    }, [user_id]);


    const [etapeFilter, setEtapeFilter] = useState('non_cloture');


    const fetchInscriptions = async (page = 1, perPage = itemsPerPage, etape = etapeFilter) => {
        setIsLoading(true);
        try {
            if (useMockData) {
                // Utiliser les données fictives pour le développement
                setTimeout(() => {
                    // Filtrer les données selon le filtre
                    let filteredData = mockData;

                    if (etape === 'non_cloture') {
                        // Filtrer toutes les inscriptions SAUF celles avec étape "Clôture"
                        filteredData = mockData.filter(ins => ins.etape !== 'Clôture');
                    } else if (etape && etape !== 'toutes') {
                        // Filtrer par étape spécifique
                        filteredData = mockData.filter(ins => ins.etape === etape);
                    }

                    setInscriptions(filteredData);

                    // Simuler la pagination côté client pour les données mock
                    const total = filteredData.length;
                    setPaginationInfo({
                        current_page: page,
                        total_pages: Math.ceil(total / perPage),
                        total_items: total,
                        items_per_page: perPage,
                        has_next: page < Math.ceil(total / perPage),
                        has_previous: page > 1
                    });

                    setIsLoading(false);
                }, 500);
            } else {
                // Construire l'URL avec les paramètres
                let url = `${process.env.REACT_APP_HOTE}/liste-inscriptions/?page=${page}&per_page=${perPage}`;

                // Ajouter le filtre spécifique pour "non_cloture"
                if (etape === 'non_cloture') {
                    url += '&exclude_etape=["Clôture", "Annulee", "Archive"]';
                } else if (etape && etape !== 'toutes') {
                    url += `&etape=${encodeURIComponent(etape)}`;
                }

                const response = await fetch(url);
                if (response.ok) {
                    const data = await response.json();
                    setInscriptions(data.data);
                    setPaginationInfo(data.pagination);
                } else {
                    console.error('Erreur lors de la récupération des inscriptions');
                    showAlert('Erreur lors du chargement des inscriptions', 'danger');
                }
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur', 'danger');
        } finally {
            setIsLoading(false);
        }
    };


    const [formations, setFormations] = useState([]);
    const [loadingFormations, setLoadingFormations] = useState(false);

    const fetchFormations = async () => {
        try {
            setLoadingFormations(true);
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-formation/');
            if (response.ok) {
                const data = await response.json();

                // Filtrer seulement les formations actives
                const formationsActives = data.filter(formation =>
                    formation.statut === "actif" ||
                    (formation.statut && formation.statut.toLowerCase() === "actif")
                );

                // CORRECTION ICI : Mettre à jour l'état formations
                setFormations(formationsActives);

            } else {
                console.error('Erreur lors de la récupération des formations');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setLoadingFormations(false);
        }
    };

    const handleFormationChange = (selectedOption) => {
        setSelectedInscription({
            ...selectedInscription,
            ref_formation: selectedOption ? selectedOption.value : ''
        });
    };

    const formatFormationPeriod = (periode) => {
        if (!periode || periode === '[]' || periode === '""' || periode === "''") {
            return "À la demande";
        }

        try {
            // Si c'est une chaîne JSON
            if (typeof periode === 'string' && (periode.startsWith('[') || periode.startsWith('"['))) {
                const cleanedPeriode = periode.replace(/'/g, '"');
                const dates = JSON.parse(cleanedPeriode);

                if (Array.isArray(dates) && dates.length > 0) {
                    return dates.map(date => {
                        try {
                            const dateObj = new Date(date);
                            return dateObj.toLocaleDateString('fr-FR', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            });
                        } catch (e) {
                            return date;
                        }
                    }).join(', ');
                }
            }

            // Si c'est déjà une date formatée
            if (typeof periode === 'string') {
                try {
                    const dateObj = new Date(periode);
                    if (!isNaN(dateObj.getTime())) {
                        return dateObj.toLocaleDateString('fr-FR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        });
                    }
                } catch (e) {
                    // Si ce n'est pas une date valide, retourner la chaîne telle quelle
                }
            }

            return periode;
        } catch (error) {
            console.warn('Erreur de parsing des dates:', error);
            return periode;
        }
    };

    // Préparer les options pour le select des formations
    // ✅ APRÈS (fonctionne même si selectedInscription est null)
    const formationOptions = formations.map(formation => {
        const typeFinancement = selectedInscription?.type_financement || 'Particulier';
        const isEntreprise = typeFinancement === "Entreprise";
        const prix = isEntreprise ? formation.prix : formation.prix_particulier;

        return {
            value: formation.reference,
            label: `${formation.nom} - ${formatFormationPeriod(formation.periode)}${prix ? ` - ${prix.toLocaleString()} FCFA` : ''}`
        };
    });

    useEffect(() => {
        fetchInscriptions();
        fetchFormations();
    }, []);

    const handleItemsPerPageChange = (e) => {
        const newPerPage = Number(e.target.value);
        setItemsPerPage(newPerPage);
        setCurrentPage(1);
        fetchInscriptions(1, newPerPage, etapeFilter);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchInscriptions(page, itemsPerPage, etapeFilter);
    };

    const handleEtapeFilterChange = (etape) => {
        setEtapeFilter(etape);
        setCurrentPage(1); // Retourner à la première page
        fetchInscriptions(1, itemsPerPage, etape);
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 3000);
    };

    const handleShowDetailModal = (inscription) => {
        setSelectedInscription(inscription);
        setShowDetailModal(true);
    };

    const handleRowClick = async (inscription) => {
        if (useMockData) {
            // Pour les données fictives
            setSelectedInscription(inscription);
            setNouveauDiscount(inscription.discount || '');
        } else {
            // Pour les données réelles
            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/inscription-details/${inscription.id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setSelectedInscription(data);
                    setNouveauDiscount(data.discount || '');
                } else {
                    // Fallback sur les données de base
                    setSelectedInscription(inscription);
                    setNouveauDiscount(inscription.discount || '');
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des détails:', error);
                setSelectedInscription(inscription);
                setNouveauDiscount(inscription.discount || '');
            }
        }
    };

    const [isLoadingModif, setIsLoadingModif] = useState(false);
    const [isLoadingCommentaire, setIsLoadingCommentaire] = useState(false);

    const handleSaveInscription = async () => {
        if (selectedInscription) {
            setIsLoadingModif(true);
            try {
                // Préparer les données pour l'envoi
                const dataToSend = {
                    user_id: user_id,
                    // 1. Dates de relance
                    date_appel: selectedInscription.date_appel || null,
                    date_relance: selectedInscription.date_relance || null,

                    // 2. Étape actuelle
                    etape: selectedInscription.etape || 'Prospection',

                    // 3. Informations de paiement
                    acompte: selectedInscription.acompte || false,
                    solde_complet: selectedInscription.solde_complet || false,
                    montant_acompte: selectedInscription.montant_acompte || null,

                    // 4. Statut de paiement pour le nouvel acompte
                    statut_paiement: selectedInscription.statut_paiement || null,

                    // 5. Nouvel acompte si saisi
                    nouveau_acompte: nouveauAcompte || null,
                    ref_formation: selectedInscription.ref_formation || null,
                };

                if (nouveauDiscount !== '' && nouveauDiscount !== null) {
                    dataToSend.discount = String(nouveauDiscount);
                }

                console.log('Données envoyées:', dataToSend);

                const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-inscription/${selectedInscription.id}/`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataToSend)
                });

                if (response.ok) {
                    const data = await response.json();
                    showAlert('Inscription mise à jour avec succès !');

                    // Mettre à jour localement les données
                    const updatedInscription = {
                        ...selectedInscription,
                        ...data.inscription,
                        // Garder les acomptes mis à jour
                        acomptes: data.acomptes || selectedInscription.acomptes,
                        // Garder les commentaires mis à jour
                        commentaires: data.commentaires || selectedInscription.commentaires,
                        // Mettre à jour le dernier commentaire
                        dernier_commentaire: data.inscription.dernier_commentaire || selectedInscription.dernier_commentaire
                    };

                    // ✅ AJOUTER ICI : mettre à jour le discount local
                    if (data.inscription.discount !== undefined) {
                        setNouveauDiscount(data.inscription.discount);
                    }

                    // ✅ AJOUTER ICI : reset de l'acompte si un nouveau a été ajouté
                    if (data.nouveau_acompte_ajoute && nouveauAcompte) {
                        setNouveauAcompte('');
                        setSelectedInscription(prev => ({
                            ...prev,
                            statut_paiement: ''
                        }));
                    }

                    // Mettre à jour l'inscription sélectionnée
                    setSelectedInscription(updatedInscription);

                    // Mettre à jour la liste des inscriptions
                    const updatedInscriptions = inscriptions.map(ins =>
                        ins.id === selectedInscription.id ? updatedInscription : ins
                    );
                    setInscriptions(updatedInscriptions);

                    // Réinitialiser le statut de paiement dans le formulaire
                    handlePaymentChange('statut_paiement', '');

                } else {
                    const errorData = await response.json();
                    showAlert(errorData.error || 'Erreur lors de la mise à jour', 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert('Erreur de connexion au serveur', 'danger');
            } finally {
                setIsLoadingModif(false);
            }
        }
    };


    const handleExportExcel = async () => {
        try {
            // Afficher un indicateur de chargement
            setIsLoading(true);

            // Appeler l'endpoint d'export
            const response = await fetch(`${process.env.REACT_APP_HOTE}/export-inscriptions-excel/`);

            if (response.ok) {
                // Créer un blob et télécharger le fichier
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;

                // Récupérer le nom de fichier depuis les headers
                const contentDisposition = response.headers.get('Content-Disposition');
                let filename = 'inscriptions.xlsx';

                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1];
                    }
                }

                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);

                showAlert('Export Excel réussi !', 'success');
            } else {
                showAlert('Erreur lors de l\'export', 'danger');
            }
        } catch (error) {
            console.error('Erreur d\'export:', error);
            showAlert('Erreur de connexion', 'danger');
        } finally {
            setIsLoading(false);
        }
    };


    const handleAddComment = async () => {
        if (newComment.trim() && selectedInscription) {
            setIsLoadingCommentaire(true);
            try {
                if (useMockData) {
                    // Simulation pour données fictives
                    setTimeout(() => {
                        const newCommentObj = {
                            id: selectedInscription.commentaires.length + 1,
                            texte: newComment.trim(),
                            date: new Date().toISOString(),
                            auteur: "Admin"
                        };

                        const updatedInscription = {
                            ...selectedInscription,
                            commentaires: [...selectedInscription.commentaires, newCommentObj],
                            dernier_commentaire: newCommentObj
                        };

                        setSelectedInscription(updatedInscription);
                        setNewComment('');
                        showAlert('Commentaire ajouté avec succès !');
                        setIsLoadingCommentaire(false);
                    }, 500);
                } else {
                    const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-commentaire/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            commentaire: newComment.trim(),
                            user_id: user_id,
                            inscription_id: selectedInscription.id
                        })
                    });

                    if (response.ok) {
                        const data = await response.json();
                        showAlert('Commentaire ajouté avec succès !');
                        const detailsResponse = await fetch(`${process.env.REACT_APP_HOTE}/inscription-details/${selectedInscription.id}/`);
                        if (detailsResponse.ok) {
                            const inscriptionData = await detailsResponse.json();
                            setSelectedInscription(inscriptionData);
                        }
                        setNewComment('');
                    } else {
                        const errorData = await response.json();
                        showAlert(errorData.error || 'Erreur lors de l\'ajout du commentaire', 'danger');
                    }
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert('Erreur de connexion au serveur', 'danger');
            } finally {
                if (!useMockData) setIsLoadingCommentaire(false);
            }
        }
    };

    // Ajouter ces états dans votre composant ListeInscriptions
    const [showDeleteAcompteModal, setShowDeleteAcompteModal] = useState(false);
    const [selectedAcompte, setSelectedAcompte] = useState(null);
    const [isDeletingAcompte, setIsDeletingAcompte] = useState(false);

    // Fonction pour supprimer un acompte
    const handleDeleteAcompte = async () => {
        if (!selectedAcompte) return;

        setIsDeletingAcompte(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-acompte/${selectedAcompte.id}/${user_id}/`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.ok) {
                const data = await response.json();
                showAlert('Acompte supprimé avec succès !', 'success');

                // Mettre à jour l'inscription sélectionnée avec les nouvelles données
                setSelectedInscription(prev => ({
                    ...prev,
                    acomptes: data.acomptes_restants,
                    montant_paye: data.inscription.montant_paye,
                    reste_a_payer: data.inscription.reste_a_payer,
                    acompte: data.inscription.acompte,
                    solde_complet: data.inscription.solde_complet,
                    commentaires: data.commentaires
                }));

                // Mettre à jour la liste des inscriptions
                const updatedInscriptions = inscriptions.map(ins =>
                    ins.id === data.inscription.id
                        ? {
                            ...ins,
                            montant_paye: data.inscription.montant_paye,
                            reste_a_payer: data.inscription.reste_a_payer,
                            acompte: data.inscription.acompte,
                            solde_complet: data.inscription.solde_complet
                        }
                        : ins
                );
                setInscriptions(updatedInscriptions);

                // Fermer le modal
                setShowDeleteAcompteModal(false);
                setSelectedAcompte(null);
            } else {
                const errorData = await response.json();
                showAlert(errorData.error || 'Erreur lors de la suppression', 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur', 'danger');
        } finally {
            setIsDeletingAcompte(false);
        }
    };

    // Fonction pour ouvrir le modal de confirmation
    const openDeleteAcompteModal = (acompte) => {
        setSelectedAcompte(acompte);
        setShowDeleteAcompteModal(true);
    };



    const [commentFilter, setCommentFilter] = useState('tous'); // 'tous', 'systeme', 'commercial'

    // Fonction pour déterminer si un commentaire vient du système
    const isSystemComment = (auteur) => {
        // Les commentaires du système ont généralement des auteurs comme "Admin", "Système", etc.
        const systemAuthors = ['Admin', 'admin', 'Système', 'systeme', 'System', 'system'];
        return systemAuthors.includes(auteur);
    };

    // Fonction pour filtrer les commentaires
    const filteredComments = selectedInscription?.commentaires?.filter(comment => {
        switch (commentFilter) {
            case 'systeme':
                return isSystemComment(comment.auteur);
            case 'commercial':
                return !isSystemComment(comment.auteur);
            case 'tous':
            default:
                return true;
        }
    }) || [];

    // Fonction pour obtenir le label du filtre
    const getFilterLabel = () => {
        switch (commentFilter) {
            case 'systeme':
                return 'Système';
            case 'commercial':
                return 'Commercial';
            case 'tous':
            default:
                return 'Tous';
        }
    };

    const handleEtapeChange = (etape) => {
        setSelectedInscription(prev => ({
            ...prev,
            etape
        }));
    };

    const handlePaymentChange = (field, value) => {
        setSelectedInscription(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleDateChange = (field, value) => {
        setSelectedInscription(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const filteredInscriptions = inscriptions.filter(inscription =>
        inscription.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
        inscription.prenoms.toLowerCase().includes(searchTerm.toLowerCase()) ||
        inscription.telephone.toLowerCase().includes(searchTerm.toLowerCase()) ||
        inscription.etape.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedInscriptions = [...filteredInscriptions].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getEtapeBadge = (etape) => {
        const etapeConfig = ETAPES.find(e => e.value === etape);
        if (!etapeConfig) return null;

        const colors = {
            'Prospection': 'default',
            'Facturation': 'default',
            'Onboarding': 'default',
            'Clôture': 'default',
            'Archive': 'default'
        };

        return (
            <span pill bg={colors[etape] || 'secondary'} className="d-flex align-items-center">
                {/* {etapeConfig.icon} */}
                <span className="ms-1">{etapeConfig.label}</span>
            </span>
        );
    };

    const getPaymentStatus = (inscription) => {
        if (inscription.solde_complet) {
            return (
                <span className="badge badge-success d-inline-flex align-items-center">
                    Soldé
                </span>
            );
        } else if (inscription.acompte) {
            return (
                <span className="badge badge-info text-dark d-inline-flex align-items-center">
                    Acompte
                </span>
            );
        } else {
            return (
                <span className="badge badge-secondary d-inline-flex align-items-center">
                    En attente
                </span>
            );
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString.replace(' ', 'T'));
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };


    function formatDateFr(text) {
        // Rechercher les dates au format YYYY-MM-DD
        const dateRegex = /(\d{4})-(\d{2})-(\d{2})/g;

        return text.replace(dateRegex, (match, year, month, day) => {
            return `${day}/${month}/${year}`;
        });
    }


    const [showArchiveModal, setShowArchiveModal] = useState(false);
    const [isArchiving, setIsArchiving] = useState(false);

    // Fonction pour archiver une inscription
    const handleArchiveInscription = async () => {
        if (!selectedInscription) {
            showAlert('Veuillez sélectionner une inscription', 'warning');
            return;
        }

        setIsArchiving(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/archiver-inscription/${selectedInscription.id}/?user_id=${user_id}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            const data = await response.json();

            if (response.ok) {
                showAlert(data.message, 'success');
                setShowArchiveModal(false);

                // Rafraîchir la liste des inscriptions
                fetchInscriptions(currentPage, itemsPerPage, etapeFilter);

                // Mettre à jour l'inscription sélectionnée avec la nouvelle étape
                setSelectedInscription(null);
            } else {
                showAlert(data.error || 'Erreur lors de l\'archivage', 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur', 'danger');
        } finally {
            setIsArchiving(false);
        }
    };

    const [visibleColumns, setVisibleColumns] = useState({
        nom: true,
        prenoms: true,
        telephone: true,
        email: true,
        profession: true,
        diplome: true,
        type_financement: true,
        date_inscription: true,
        date_appel: false,
        date_relance: false,
        etape: true,
        montant_acompte: false
    });

    // Fonction pour basculer la visibilité d'une colonne
    const toggleColumn = (columnName) => {
        setVisibleColumns(prev => ({
            ...prev,
            [columnName]: !prev[columnName]
        }));
    };

    // Fonction pour réinitialiser toutes les colonnes visibles
    const resetColumns = () => {
        setVisibleColumns({
            nom: true,
            prenoms: true,
            telephone: true,
            email: true,
            profession: true,
            diplome: true,
            type_financement: true,
            date_inscription: true,
            date_appel: true,
            date_relance: true,
            etape: true,
            montant_acompte: true
        });
    };

    // Fonction pour obtenir la couleur selon l'étape
    const getEtapeColor = (etape) => {
        const colors = {
            'Prospection': '#3498db',
            'Facturation': '#9b59b6',
            'Onboarding': '#2ecc71',
            'Clôture': '#27ae60',
            'Annulee': '#e74c3c'
        };
        return colors[etape] || '#95a5a6';
    };

    // Fonction pour calculer le pourcentage de paiement
    const getPaymentPercentage = (inscription) => {
        if (!inscription) return 0;

        try {
            const montantTotal = parseFloat(inscription.montant_a_payer?.replace(' FCFA', '') || '0');
            const montantPaye = parseFloat(inscription.montant_paye?.replace(' FCFA', '') || '0');

            if (montantTotal === 0) return 100;
            return Math.min(100, (montantPaye / montantTotal) * 100);
        } catch (e) {
            return 0;
        }
    };


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaUserClock size={25} className='mr-2' />Inscriptions
                            </h2>
                            <small>Suivez le parcours de chaque inscrit étape par étape</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-inscriptions`}> Inscriptions</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="col-lg-12 d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                                <h5>Liste des inscriptions ({paginationInfo.total_items})</h5>

                                <div className="d-flex flex-column flex-md-row mt-3 mt-md-0">
                                    <div className="row">
                                        <button
                                            onClick={() => setShowAddModal(true)}
                                            className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                        >
                                            <FaPlus className="mr-1" />
                                            <span className="d-none d-sm-inline">
                                                Ajouter
                                            </span>
                                        </button>
                                        <InscriptionModal
                                            show={showAddModal}
                                            onHide={() => setShowAddModal(false)}
                                            onSuccess={() => {
                                                // Rafraîchir la liste des inscriptions après un ajout réussi
                                                fetchInscriptions();
                                            }}
                                        />

                                        <button
                                            onClick={() => handleShowDetailModal(selectedInscription)}
                                            className={`btn d-flex align-items-center justify-content-center mt-1 mr-2 ${selectedInscription ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedInscription}
                                        >
                                            {/* <FaDetails /> */}
                                            <span className="d-none d-sm-inline">
                                                Détails
                                            </span>
                                        </button>

                                        <button
                                            onClick={() => {
                                                if (selectedInscription) {
                                                    setShowArchiveModal(true);
                                                } else {
                                                    showAlert('Veuillez sélectionner une inscription', 'warning');
                                                }
                                            }}
                                            className={`btn d-flex align-items-center justify-content-center mt-1 mr-2 ${selectedInscription ? 'btn-warning' : 'btn-default text-dark'}`}
                                            disabled={!selectedInscription || selectedInscription.etape === 'Archive'}
                                            title={selectedInscription?.etape === 'Archive' ? 'Cette inscription est déjà archivée' : 'Archiver l\'inscription'}
                                        >
                                            <FaSyncAlt className="mr-1" />
                                            <span className="d-none d-sm-inline">
                                                {selectedInscription?.etape === 'Archive' ? 'Archivé' : 'Archiver'}
                                            </span>
                                        </button>
                                        <button
                                            onClick={handleExportExcel}
                                            className="btn btn-success d-flex align-items-center justify-content-center ms-2 mt-1"
                                        >
                                            <FaFileExport />
                                            <span className="d-none d-sm-inline ml-2">
                                                Exporter
                                            </span>
                                        </button>

                                        {/* <button
                                            onClick={() => {
                                                if (selectedInscription) {
                                                    setShowEditModal(true);
                                                }
                                            }}
                                            className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 ${selectedInscription ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedInscription}
                                        >
                                            <FaCalendarAlt />
                                            <span className="d-none d-sm-inline ml-2">
                                                Modifier
                                            </span>
                                        </button> */}
                                    </div>
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                                    {alert.message}
                                    <button type="button" className="close" onClick={() => setAlert({ message: '', type: '' })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                            )}

                            <div className="row">
                                {/* Liste des inscriptions - 100% de largeur */}
                                <div className="col-lg-12 d-flex">
                                    <div className="ibox-content flex-fill d-flex flex-column mb-0">
                                        <div className=" flex-fill d-flex flex-column p-0">
                                            {/* En-tête avec recherche et pagination */}
                                            <div className="p-3" style={{ flexShrink: 0 }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="w-100 d-flex align-items-center justify-content-between">
                                                        <div className="d-flex align-items-center">
                                                            <div className="me-2">
                                                                <select
                                                                    value={itemsPerPage}
                                                                    onChange={handleItemsPerPageChange}
                                                                    className="form-select bg-default p-1"
                                                                    style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                                >
                                                                    <option value={5}>5</option>
                                                                    <option value={10}>10</option>
                                                                    <option value={20}>20</option>
                                                                    <option value={50}>50</option>
                                                                </select>
                                                            </div>

                                                            <Dropdown className="ml-2">
                                                                <Dropdown.Toggle className="btn btn-success d-flex align-items-center justify-content-center">
                                                                    <FaEye className="mr-1" />
                                                                    <span className="d-none d-sm-inline">
                                                                        Visibilité
                                                                    </span>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {Object.entries(visibleColumns).map(([column, isVisible]) => (
                                                                        <Dropdown.Item
                                                                            key={column}
                                                                            onClick={() => toggleColumn(column)}
                                                                            className="d-flex justify-content-between align-items-center"
                                                                        >
                                                                            <span>
                                                                                {column === 'nom' && 'Nom'}
                                                                                {column === 'prenoms' && 'Prénoms'}
                                                                                {column === 'telephone' && 'Téléphone'}
                                                                                {column === 'email' && 'Email'}
                                                                                {column === 'profession' && 'Profession'}
                                                                                {column === 'diplome' && 'Diplôme'}
                                                                                {column === 'type_financement' && 'Type Financement'}
                                                                                {column === 'date_inscription' && 'Inscrit le'}
                                                                                {column === 'date_appel' && 'Dernière relance'}
                                                                                {column === 'date_relance' && 'Relance à venir'}
                                                                                {column === 'etape' && 'Étape'}
                                                                                {column === 'montant_acompte' && 'Acompte'}
                                                                            </span>
                                                                            {isVisible && <FaCheck size={12} />}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            </Dropdown>

                                                            {/* Filtre par étape placé ici */}
                                                            <Dropdown className="ml-2">
                                                                <Dropdown.Toggle className="btn btn-success d-flex align-items-center justify-content-center">
                                                                    <FaFilter className="mr-1" size={12} />
                                                                    <span>
                                                                        {etapeFilter === 'toutes' ? 'Toutes' :
                                                                            etapeFilter === 'non_cloture' ? 'En cours' :
                                                                                etapeFilter === 'Clôture' ? 'Clôture' :
                                                                                    etapeFilter}
                                                                    </span>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        onClick={() => handleEtapeFilterChange('toutes')}
                                                                        className="d-flex justify-content-between align-items-center"
                                                                    >
                                                                        <span>Toutes les inscriptions</span>
                                                                        {etapeFilter === 'toutes' && <FaCheck size={12} />}
                                                                    </Dropdown.Item>

                                                                    <Dropdown.Item
                                                                        onClick={() => handleEtapeFilterChange('non_cloture')}
                                                                        className="d-flex justify-content-between align-items-center"
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <span>En cours</span>
                                                                        </div>
                                                                        {etapeFilter === 'non_cloture' && <FaCheck size={12} />}
                                                                    </Dropdown.Item>

                                                                    <Dropdown.Item
                                                                        onClick={() => handleEtapeFilterChange('Clôture')}
                                                                        className="d-flex justify-content-between align-items-center"
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <span>Clôture</span>
                                                                        </div>
                                                                        {etapeFilter === 'Clôture' && <FaCheck size={12} />}
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>

                                                        <input
                                                            type="text"
                                                            placeholder="Rechercher..."
                                                            className="form-control"
                                                            style={{ maxWidth: '250px', width: '100%' }}
                                                            value={searchTerm}
                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Tableau - Prend toute la hauteur disponible */}
                                            <div className="flex-grow-1" style={{ overflow: 'auto' }}>
                                                <div className="table-responsive p-2" style={{ fontSize: '14px', height: '100%' }}>
                                                    <table className="footable table table-hover footable-loaded">
                                                        <thead>
                                                            <tr>
                                                                {visibleColumns.date_inscription && (
                                                                    <th className='text-secondary' onClick={() => handleSort('date_inscription')}>
                                                                        Inscrit le {sortConfig.key === 'date_inscription' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.nom && (
                                                                    <th className='text-secondary' onClick={() => handleSort('nom')}>
                                                                        Nom {sortConfig.key === 'nom' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.prenoms && (
                                                                    <th className='text-secondary' onClick={() => handleSort('prenoms')}>
                                                                        Prénoms {sortConfig.key === 'prenoms' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.telephone && (
                                                                    <th className='text-secondary' onClick={() => handleSort('telephone')}>
                                                                        Téléphone {sortConfig.key === 'telephone' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.email && (
                                                                    <th className='text-secondary' onClick={() => handleSort('email')}>
                                                                        Email {sortConfig.key === 'email' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.profession && (
                                                                    <th className='text-secondary' onClick={() => handleSort('profession')}>
                                                                        Profession {sortConfig.key === 'profession' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.diplome && (
                                                                    <th className='text-secondary' onClick={() => handleSort('diplome')}>
                                                                        Diplôme {sortConfig.key === 'diplome' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.type_financement && (
                                                                    <th className='text-secondary' onClick={() => handleSort('type_financement')}>
                                                                        Type Financement {sortConfig.key === 'type_financement' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.date_appel && (
                                                                    <th className='text-secondary text-center' onClick={() => handleSort('date_appel')}>
                                                                        Dernière relance {sortConfig.key === 'date_appel' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.date_relance && (
                                                                    <th className='text-secondary text-center' onClick={() => handleSort('date_relance')}>
                                                                        Relance à venir {sortConfig.key === 'date_relance' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.etape && (
                                                                    <th className='text-secondary' onClick={() => handleSort('etape')}>
                                                                        Étape {sortConfig.key === 'etape' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                                {visibleColumns.montant_acompte && (
                                                                    <th className='text-secondary text-center' onClick={() => handleSort('montant_acompte')}>
                                                                        Acompte {sortConfig.key === 'montant_acompte' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!isLoading ? (
                                                                filteredInscriptions.length > 0 ? (
                                                                    filteredInscriptions.map((inscription) => (
                                                                        <tr
                                                                            key={inscription.id}
                                                                            onClick={() => handleRowClick(inscription)}
                                                                            className={`cursor-pointer ${selectedInscription && selectedInscription.id === inscription.id ? 'bg-success text-white' : ''}`}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {visibleColumns.date_inscription && (
                                                                                <td className="">
                                                                                    {inscription.date_inscription ? (
                                                                                        <small>{new Date(inscription.date_inscription).toLocaleDateString()}</small>
                                                                                    ) : (
                                                                                        <small className="text-muted">-</small>
                                                                                    )}
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.nom && (
                                                                                <td>
                                                                                    <small>{inscription.nom}</small>
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.prenoms && (
                                                                                <td>
                                                                                    <small>{inscription.prenoms}</small>
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.telephone && (
                                                                                <td>
                                                                                    <small>{inscription.telephone}</small>
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.email && (
                                                                                <td>
                                                                                    <small>{inscription.email}</small>
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.profession && (
                                                                                <td>
                                                                                    <small>{inscription.profession}</small>
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.diplome && (
                                                                                <td>
                                                                                    <small>{inscription.diplome}</small>
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.type_financement && (
                                                                                <td>
                                                                                    <small>{inscription.type_financement}</small>
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.date_appel && (
                                                                                <td className="text-center">
                                                                                    {inscription.date_appel ? (
                                                                                        <small>{new Date(inscription.date_appel).toLocaleDateString()}</small>
                                                                                    ) : (
                                                                                        <small className="text-muted">-</small>
                                                                                    )}
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.date_relance && (
                                                                                <td className="text-center">
                                                                                    {inscription.date_relance ? (
                                                                                        <small>{new Date(inscription.date_relance).toLocaleDateString()}</small>
                                                                                    ) : (
                                                                                        <small className="text-muted">-</small>
                                                                                    )}
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.etape && (
                                                                                <td>
                                                                                    <div className="d-flex">
                                                                                        {getEtapeBadge(inscription.etape)}
                                                                                    </div>
                                                                                </td>
                                                                            )}
                                                                            {visibleColumns.montant_acompte && (
                                                                                <td className="text-center">
                                                                                    {inscription.montant_acompte ? (
                                                                                        <small>{inscription.montant_acompte}</small>
                                                                                    ) : (
                                                                                        <small className="text-muted">-</small>
                                                                                    )}
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={Object.values(visibleColumns).filter(v => v).length} className="text-center p-4">
                                                                            <div className="text-muted">
                                                                                <p>
                                                                                    {etapeFilter !== 'toutes'
                                                                                        ? `Aucune inscription trouvée pour l'étape "${etapeFilter}"`
                                                                                        : searchTerm
                                                                                            ? `Aucune inscription trouvée pour "${searchTerm}"`
                                                                                            : 'Aucune inscription trouvée'
                                                                                    }
                                                                                </p>
                                                                                {etapeFilter !== 'toutes' && (
                                                                                    <button
                                                                                        className="btn btn-sm btn-outline-info mt-2"
                                                                                        onClick={() => handleEtapeFilterChange('toutes')}
                                                                                    >
                                                                                        Voir toutes les inscriptions
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={Object.values(visibleColumns).filter(v => v).length} className="text-center p-5">
                                                                        <div className="d-flex justify-content-center align-items-center">
                                                                            <div className="spiner-example">
                                                                                <div className="sk-spinner sk-spinner-wave">
                                                                                    <div className="sk-rect1 mr-1"></div>
                                                                                    <div className="sk-rect2 mr-1"></div>
                                                                                    <div className="sk-rect3 mr-1"></div>
                                                                                    <div className="sk-rect4 mr-1"></div>
                                                                                    <div className="sk-rect5"></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mt-2">Chargement des inscriptions...</div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Pagination - Fixe en bas */}
                                        <div className="d-flex justify-content-between align-items-center m-2">
                                            <div className="dataTables_info" role="status" aria-live="polite">
                                                {paginationInfo.total_items === 0
                                                    ? "Aucune inscription à afficher"
                                                    : `Élément ${(paginationInfo.current_page - 1) * paginationInfo.items_per_page + 1} à ${Math.min(paginationInfo.current_page * paginationInfo.items_per_page, paginationInfo.total_items)} sur ${paginationInfo.total_items}`}
                                                {/* {etapeFilter !== 'toutes' && (
                                                    <span className="ms-2 text-info">
                                                        <FaFilter size={10} className="me-1" />
                                                        Filtre: {etapeFilter}
                                                    </span>
                                                )} */}
                                            </div>
                                            <div>
                                                <button
                                                    onClick={() => handlePageChange(paginationInfo.current_page - 1)}
                                                    className="btn btn-light mx-1"
                                                    disabled={!paginationInfo.has_previous}
                                                >
                                                    <FaArrowLeft />
                                                </button>

                                                {(() => {
                                                    const pagesToShow = 5;
                                                    let startPage = Math.max(1, paginationInfo.current_page - Math.floor(pagesToShow / 2));
                                                    let endPage = Math.min(paginationInfo.total_pages, startPage + pagesToShow - 1);

                                                    if (endPage - startPage < pagesToShow - 1) {
                                                        startPage = Math.max(1, endPage - pagesToShow + 1);
                                                    }

                                                    const pageButtons = [];

                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageButtons.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => handlePageChange(i)}
                                                                className={`btn ${paginationInfo.current_page === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }

                                                    return pageButtons;
                                                })()}

                                                <button
                                                    onClick={() => handlePageChange(paginationInfo.current_page + 1)}
                                                    className="btn btn-light mx-1"
                                                    disabled={!paginationInfo.has_next}
                                                >
                                                    <FaArrowRight />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal de détails - NOUVELLE VERSION */}
                    <Modal show={showDetailModal} onHide={() => {
                        setShowDetailModal(false);
                        setNouveauDiscount('');
                        setNouveauAcompte('');
                    }} size="xl">

                        <Modal.Header className="py-2 p-4" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                            <div className="w-100">
                                {/* Titre principal avec nom */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <div>
                                        <h4 className="mb-1" style={{ fontWeight: '700', color: '#2c3e50' }}>
                                            {selectedInscription?.prenoms} {selectedInscription?.nom}
                                        </h4>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="text-muted">
                                                Inscrit le : {selectedInscription?.date_inscription ?
                                                    new Date(selectedInscription.date_inscription).toLocaleDateString('fr-FR') :
                                                    'Non spécifié'} pour la formation
                                            </div>
                                            <div className="fw-bold ml-1" style={{ fontSize: '0.9rem' }}>
                                                {selectedInscription?.formation?.nom ||
                                                    (selectedInscription?.ref_formation ?
                                                        `Réf: ${selectedInscription.ref_formation}` :
                                                        "Néant")}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Grille de statistiques */}
                                <div className="row g-3 mb-3">
                                    {/* Carte 1: Informations complètes */}
                                    <div className="col-md-3">
                                        <div className="card border-0 shadow-sm h-100" style={{
                                            background: 'white',
                                            borderRadius: '12px'
                                        }}>
                                            <div className="card-body p-3">
                                                {/* Email */}
                                                <div className="d-flex align-items-center mb-2">
                                                    <FaEnvelope className="mr-2 text-success" size={14} />
                                                    <div className="d-flex justify-content-between w-100">
                                                        {/* <span className="fw-bold">Email:</span> */}
                                                        <span className="fw-bold text-end ms-2">
                                                            {selectedInscription?.email || "Non spécifié"}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Diplôme */}
                                                <div className="d-flex align-items-center mb-2">
                                                    <FaGraduationCap className="mr-2 text-success" size={14} />
                                                    <div className="d-flex justify-content-between w-100">
                                                        <span className="fw-bold"><strong>Diplôme :</strong></span>
                                                        <span className="fw-bold text-end ms-2" style={{ fontSize: '0.75rem', wordBreak: 'break-word', maxWidth: '70%' }}>
                                                            {selectedInscription?.diplome || "Non"}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Téléphone */}
                                                <div className="d-flex align-items-center mb-2">
                                                    <FaPhone className="mr-2 text-success" size={14} />
                                                    <div className="d-flex justify-content-between w-100">
                                                        <span className="fw-bold"><strong>Téléphone :</strong></span>
                                                        <span className="fw-bold text-end ms-2" style={{ fontSize: '0.75rem', wordBreak: 'break-word', maxWidth: '70%' }}>
                                                            {selectedInscription?.telephone || "Non"}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Type Financement */}
                                                <div className="d-flex align-items-center mb-2">
                                                    <FaMoneyBillWave className="mr-2 text-success" size={14} />
                                                    <div className="d-flex justify-content-between w-100">
                                                        <span className="fw-bold"><strong>Financement :</strong></span>
                                                        <span className="fw-bold text-end ms-2" style={{ fontSize: '0.75rem', wordBreak: 'break-word', maxWidth: '70%' }}>
                                                            {selectedInscription?.type_financement || "Non"}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Entreprise */}
                                                <div className="d-flex align-items-center mb-2">
                                                    <FaBuilding className="mr-2 text-success" size={14} />
                                                    <div className="d-flex justify-content-between w-100">
                                                        <span className="fw-bold"><strong>Entreprise :</strong></span>
                                                        <span className="fw-bold text-end ms-2" style={{ fontSize: '0.75rem', wordBreak: 'break-word', maxWidth: '70%' }}>
                                                            {selectedInscription?.entreprise || "Pas d'entreprise"}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Eligibilité */}
                                                <div className="d-flex align-items-center">
                                                    <FaPercentage className="mr-2 text-success" size={14} />
                                                    <div className="d-flex justify-content-between w-100">
                                                        <span className="fw-bold"><strong>Eligibilité score :</strong></span>
                                                        <span className="fw-bold text-end ms-2" style={{ fontSize: '0.75rem', wordBreak: 'break-word', maxWidth: '70%' }}>
                                                            {selectedInscription?.score || "0"}%
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Carte 2: Suivi commercial */}
                                    <div className="col-md-3">
                                        <div className="card border-0 shadow-sm h-100" style={{
                                            background: 'white',
                                            borderRadius: '12px'
                                        }}>
                                            <div className="card-body p-3">
                                                {/* En-tête avec icône et titre */}
                                                <div className="d-flex align-items-center mb-3">
                                                    <FaUsersCog className="mr-2 text-success" size={16} />
                                                    <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: '600' }}>
                                                        Suivi commercial
                                                    </h6>
                                                </div>

                                                {/* Dernier contact */}
                                                <div className="d-flex align-items-center mb-3">
                                                    <FaCalendarAlt className="mr-2 text-success" size={14} />
                                                    <div className="d-flex align-items-center justify-content-between w-100">
                                                        <strong>Dernier contact:</strong>
                                                        <span className="fw-bold" style={{ fontSize: '0.75rem' }}>
                                                            {selectedInscription?.date_appel ?
                                                                new Date(selectedInscription.date_appel).toLocaleDateString('fr-FR') :
                                                                'Non planifié'}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Prochaine relance */}
                                                <div className="d-flex align-items-center mb-3">
                                                    <FaSyncAlt className="mr-2 text-success" size={14} />
                                                    <div className="d-flex align-items-center justify-content-between w-100">
                                                        <strong>Prochaine relance:</strong>
                                                        <span className="fw-bold" style={{ fontSize: '0.75rem' }}>
                                                            {selectedInscription?.date_relance ?
                                                                new Date(selectedInscription.date_relance).toLocaleDateString('fr-FR') :
                                                                'Non planifié'}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Étape */}
                                                <div className="d-flex align-items-center mb-3">
                                                    <FaFlagCheckered className="mr-2 text-success" size={14} />
                                                    <div className="d-flex align-items-center justify-content-between w-100">
                                                        <strong>Étape:</strong>
                                                        <span className="fw-bold" style={{ fontSize: '0.75rem' }}>
                                                            {selectedInscription?.etape || 'Prospection'}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* partenaire */}
                                                <div className="d-flex align-items-center mb-2">
                                                    <FaUser className="mr-2 text-success" size={14} />
                                                    <div className="d-flex align-items-center justify-content-between w-100">
                                                        <strong>Partenaire:</strong>
                                                        <span className="fw-bold" style={{ fontSize: '0.75rem' }}>
                                                            {selectedInscription?.partenaire_info ?
                                                                `${selectedInscription.partenaire_info.nom} ${selectedInscription.partenaire_info.prenoms}(${selectedInscription.partenaire_info.pourcentage_partenariat}%)` :
                                                                'Aucun partenaire'}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Commission partenaire (si existe) */}
                                                {/* {selectedInscription?.partenaire_info && (
                                                    <div className="d-flex align-items-center">
                                                        <FaPercentage className="mr-2 text-success" size={14} />
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <strong>Commission:</strong>
                                                            <span className="fw-bold text-success" style={{ fontSize: '0.75rem' }}>
                                                                {selectedInscription.partenaire_info.pourcentage_partenariat || 0}%
                                                            </span>
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Carte 3: Finance */}
                                    <div className="col-md-3">
                                        <div className="card border-0 shadow-sm h-100" style={{
                                            background: 'white',
                                            borderRadius: '12px'
                                        }}>
                                            <div className="card-body p-3">
                                                {/* En-tête avec icône et titre */}
                                                <div className="d-flex align-items-center mb-3">
                                                    <FaMoneyBillWave className="mr-2 text-success" size={16} />
                                                    <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: '600' }}>
                                                        Finance
                                                    </h6>
                                                </div>

                                                {/* Contenu financier */}
                                                <div>
                                                    {/* Montant facturé */}
                                                    <div className="d-flex align-items-center mb-2">
                                                        <FaFileInvoiceDollar className="mr-2 text-success" size={14} />
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <strong>Montant facturé:</strong>
                                                            <small className="" style={{ fontSize: '0.75rem' }}>
                                                                {selectedInscription?.montant_facture || "0"} FCFA
                                                            </small>
                                                        </div>
                                                    </div>

                                                    {/* Discount */}
                                                    <div className="d-flex align-items-center mb-2">
                                                        <FaTag className="mr-2 text-success" size={14} />
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <strong>Discount:</strong>
                                                            <small className="" style={{ fontSize: '0.75rem' }}>
                                                                {selectedInscription?.discount || "0"}%
                                                            </small>
                                                        </div>
                                                    </div>

                                                    {/* À payer */}
                                                    <div className="d-flex align-items-center mb-2">
                                                        <FaMoneyBill className="mr-2 text-success" size={14} />
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <strong>À payer:</strong>
                                                            <small className="" style={{ fontSize: '0.75rem' }}>
                                                                {selectedInscription?.montant_a_payer || "0"} FCFA
                                                            </small>
                                                        </div>
                                                    </div>

                                                    {/* Déjà payé */}
                                                    <div className="d-flex align-items-center mb-2">
                                                        <FaCheckCircle className="mr-2 text-success" size={14} />
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <strong>Déjà payé:</strong>
                                                            <small className="" style={{ fontSize: '0.75rem' }}>
                                                                {selectedInscription?.montant_paye || "0"} FCFA
                                                            </small>
                                                        </div>
                                                    </div>

                                                    {/* Reste à payer */}
                                                    <div className="d-flex align-items-center">
                                                        <FaClock className="mr-2 text-success" size={14} />
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <strong>Reste à payer:</strong>
                                                            <small className="" style={{ fontSize: '0.75rem' }}>
                                                                {selectedInscription?.reste_a_payer || "0"} FCFA
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Carte 4: Dernier commentaire */}
                                    <div className="col-md-3">
                                        <div className="card border-0 shadow-sm h-100" style={{
                                            background: 'white',
                                            borderRadius: '12px'
                                        }}>
                                            <div className="card-body p-3">
                                                {/* En-tête avec icône et titre */}
                                                <div className="d-flex align-items-center mb-3">
                                                    <FaComment className="mr-2 text-success" size={16} />
                                                    <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: '600' }}>
                                                        Dernier commentaire
                                                    </h6>
                                                </div>

                                                {/* Contenu du commentaire */}
                                                {selectedInscription?.dernier_commentaire ? (
                                                    <div className="d-flex flex-column">
                                                        {/* Carte du commentaire */}
                                                        <div className="p-3" style={{
                                                            background: '#f8f9fa',
                                                            borderRadius: '10px',
                                                            border: '1px solid #e9ecef'
                                                        }}>
                                                            {/* En-tête avec auteur et date */}
                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                <div className="d-flex align-items-center">
                                                                    <div style={{
                                                                        width: '36px',
                                                                        height: '36px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: isSystemComment(selectedInscription.dernier_commentaire.auteur) ? '#007bff' : '#28a745',
                                                                        color: 'white',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        marginRight: '10px'
                                                                    }}>
                                                                        {isSystemComment(selectedInscription.dernier_commentaire.auteur) ? (
                                                                            <FaRobot size={16} />
                                                                        ) : (
                                                                            <FaUser size={16} />
                                                                        )}
                                                                    </div>
                                                                    <div>
                                                                        <div className="fw-bold" style={{ fontSize: '0.9rem' }}>
                                                                            {selectedInscription.dernier_commentaire.auteur}
                                                                        </div>
                                                                        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                                                                            {formatDate(selectedInscription.dernier_commentaire.date)}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Contenu du commentaire */}
                                                            <div>
                                                                <div className="fw-bold" style={{
                                                                    fontSize: '0.85rem',
                                                                    lineHeight: '1.5',
                                                                    wordBreak: 'break-word',
                                                                    color: '#495057'
                                                                }}>
                                                                    <small>{formatDateFr(selectedInscription.dernier_commentaire.texte)}</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex flex-column justify-content-center align-items-center h-100 py-4">
                                                        <FaComment size={28} className="text-muted mb-2" />
                                                        <div className="text-center">
                                                            <div className="fw-bold text-muted mb-1">Aucun commentaire</div>
                                                            <div className="text-muted small" style={{ fontSize: '0.8rem' }}>
                                                                Commencez la conversation
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedInscription && (
                                <div className="row">
                                    {/* Colonne 1: Infos personnelles - Hauteur fixe */}
                                    <div className="col-md-4">
                                        <div className="card">
                                            <div className="card-header bg-light">
                                                <strong>Infos personnel</strong>
                                            </div>
                                            <div className="card-body">
                                                <div className="row mb-2">
                                                    <div className="col-6">
                                                        <div><strong>Nom:</strong></div>
                                                        <p className="mb-1">{selectedInscription.nom}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <div><strong>Prénoms:</strong></div>
                                                        <p className="mb-1">{selectedInscription.prenoms}</p>
                                                    </div>
                                                </div>

                                                <div className="row mb-2">
                                                    <div className="col-12">
                                                        <div><strong>Email:</strong></div>
                                                        <p className="mb-1">
                                                            <a href={`mailto:${selectedInscription.email}`} className="text-decoration-none">
                                                                {selectedInscription.email}
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="row mb-2">
                                                    <div className="col-6">
                                                        <div><strong>Téléphone:</strong></div>
                                                        <p className="mb-1">
                                                            <a href={`tel:${selectedInscription.telephone}`} className="text-decoration-none">
                                                                {selectedInscription.telephone}
                                                            </a>
                                                        </p>
                                                    </div>
                                                    <div className="col-6">
                                                        <div><strong>Profession:</strong></div>
                                                        <p className="mb-1">{selectedInscription.profession}</p>
                                                    </div>
                                                </div>

                                                <div className="row mb-2">
                                                    <div className="col-6">
                                                        <div><strong>Diplôme:</strong></div>
                                                        <p className="mb-1">{selectedInscription.diplome}</p>
                                                    </div>
                                                    <div className="col-6">
                                                        <div><strong>Financement:</strong></div>
                                                        <p className="mb-1">{selectedInscription.type_financement}</p>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-6">
                                                        <div><strong>Inscrit le:</strong></div>
                                                        <p className="mb-0">
                                                            {selectedInscription.date_inscription ?
                                                                new Date(selectedInscription.date_inscription).toLocaleDateString() :
                                                                'Non spécifiée'}
                                                        </p>
                                                    </div>
                                                    <div className="col-6">
                                                        <div><strong>Statut:</strong></div>
                                                        <div>{getPaymentStatus(selectedInscription)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12 mb-3">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Formation
                                                    </Form.Label>
                                                    {loadingFormations ? (
                                                        <div className="form-control" style={{ padding: '0.375rem 0.75rem' }}>
                                                            <small className="text-muted">Chargement des formations...</small>
                                                        </div>
                                                    ) : (
                                                        <div className="col-12 mb-3 ml-0"> {/* ← CECI CAUSE LE DÉCALAGE */}
                                                            <Form.Group> {/* ← IMBRICATION INUTILE */}
                                                                {loadingFormations ? (
                                                                    <div className="form-control" style={{ padding: '0.375rem 0.75rem' }}>
                                                                        <small className="text-muted">Chargement des formations...</small>
                                                                    </div>
                                                                ) : (
                                                                    <div className="row g-2 align-items-center">
                                                                        {/* Colonne pour le Select */}
                                                                        <div className="col-9 p-0">
                                                                            <Select
                                                                                options={formationOptions}
                                                                                value={formationOptions.find(option => option.value === selectedInscription.ref_formation)}
                                                                                onChange={handleFormationChange}
                                                                                placeholder="Sélectionnez une formation"
                                                                                isClearable
                                                                                required
                                                                                styles={{
                                                                                    control: (base) => ({
                                                                                        ...base,
                                                                                        minHeight: '38px',
                                                                                        fontSize: '14px'
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </div>

                                                                        {/* Colonne pour le bouton */}
                                                                        <div className="col-3">
                                                                            <Button
                                                                                variant="success"
                                                                                onClick={handleSaveInscription}
                                                                                disabled={isLoadingModif}
                                                                                className="w-100"
                                                                                size="sm"
                                                                                style={{ minHeight: '38px' }}
                                                                            >
                                                                                {isLoadingModif ? '...' : <FaSave />}
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </Form.Group>
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Colonne 2: Suivi - Hauteur moyenne */}
                                    <div className="col-md-4">
                                        <div className="card">
                                            <div className="card-header bg-light">
                                                <strong>Suivi</strong>
                                            </div>
                                            <div className="card-body">
                                                {/* Tableau des acomptes */}
                                                <div className="mb-3">
                                                    <small><strong>Historique des acomptes:</strong></small>
                                                    <div className="table-responsive mt-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>

                                                        <table className="table table-striped table-hover mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th>Date</th>
                                                                    <th>Type</th>
                                                                    <th>Montant</th>
                                                                    <th style={{ width: '50px' }}>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {selectedInscription.acomptes && selectedInscription.acomptes.length > 0 ? (
                                                                    selectedInscription.acomptes.map((acompte, index) => (
                                                                        <tr key={acompte.id || index}>
                                                                            <td>{new Date(acompte.date).toLocaleDateString()}</td>
                                                                            <td>
                                                                                <span className={`badge ${acompte.type === 'Acompte' ? 'badge-info' : 'badge-success'}`}>
                                                                                    {acompte.type}
                                                                                </span>
                                                                            </td>
                                                                            <td>{acompte.montant} FCFA</td>
                                                                            <td className="text-center">
                                                                                <Button
                                                                                    variant="danger"
                                                                                    size="sm"
                                                                                    onClick={() => openDeleteAcompteModal(acompte)}
                                                                                    title="Supprimer l'acompte"
                                                                                    className="p-0 px-2"
                                                                                    style={{ fontSize: '12px' }}
                                                                                >
                                                                                    <FaTrash size={12} />
                                                                                </Button>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="4" className="text-center text-muted py-2">
                                                                            <small>Aucun acompte</small>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>

                                                {/* Nouveau formulaire pour ajouter un acompte */}
                                                <div className="text-bottom mb-3">
                                                    {/* <small><strong>Ajouter un paiement:</strong></small> */}
                                                    <div className="mt-1">
                                                        <div className="d-flex align-items-center">
                                                            <Form.Select
                                                                value={selectedInscription.statut_paiement || ''}
                                                                onChange={(e) => handlePaymentChange('statut_paiement', e.target.value)}
                                                                size="sm"
                                                                className="custom-select me-2 flex-grow-1"
                                                                style={{ height: 'calc(1.5em + 0.75rem + 2px)' }}
                                                            >
                                                                <option value="">Type</option>
                                                                <option value="acompte">Acompte</option>
                                                                <option value="soldé">Soldé</option>
                                                            </Form.Select>

                                                            <Form.Control
                                                                type="number"
                                                                placeholder="Montant"
                                                                value={nouveauAcompte}
                                                                onChange={(e) => setNouveauAcompte(e.target.value)}
                                                                size="sm"
                                                                className="ml-4 flex-grow-1"
                                                                style={{ height: 'calc(1.5em + 0.75rem + 2px)' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Liste de sélection des étapes */}
                                                <div className="mb-3">
                                                    <strong>Étape actuelle:</strong>
                                                    <Form.Select
                                                        value={selectedInscription.etape}
                                                        onChange={(e) => handleEtapeChange(e.target.value)}
                                                        size="sm"
                                                        className="mt-1 custom-select"
                                                    >
                                                        {ETAPES.map((etape) => (
                                                            <option key={etape.value} value={etape.value}>
                                                                {etape.label}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </div>

                                                {/* Dates de relance modifiables */}
                                                <div className="d-flex">
                                                    <div className="">
                                                        <strong>Dernier contact:</strong>
                                                        <Form.Control
                                                            type="date"
                                                            value={selectedInscription.date_appel || ''}
                                                            onChange={(e) => {
                                                                const newDate = e.target.value;
                                                                handleDateChange('date_appel', newDate);

                                                                // Si une date d'appel est définie, calculer automatiquement la date de relance (+7 jours)
                                                                if (newDate) {
                                                                    const appelDate = new Date(newDate);
                                                                    const relanceDate = new Date(appelDate);
                                                                    relanceDate.setDate(relanceDate.getDate() + 7);

                                                                    // Formater la date au format YYYY-MM-DD
                                                                    const formattedRelanceDate = relanceDate.toISOString().split('T')[0];
                                                                    handleDateChange('date_relance', formattedRelanceDate);
                                                                } else {
                                                                    // Si la date d'appel est effacée, effacer aussi la date de relance
                                                                    handleDateChange('date_relance', '');
                                                                }
                                                            }}
                                                            size="sm"
                                                            className="mt-1"
                                                        />
                                                    </div>
                                                    <div className="ml-4">
                                                        <strong>Prochaine relance:</strong>
                                                        <Form.Control
                                                            type="date"
                                                            value={selectedInscription.date_relance || ''}
                                                            onChange={(e) => handleDateChange('date_relance', e.target.value)}
                                                            size="sm"
                                                            className="mt-1"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Discount */}
                                                <div className="mb-3">
                                                    <small><strong>Discount (%):</strong></small>
                                                    <div className="d-flex align-items-center mt-1">
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            max="100"
                                                            step="0.01"
                                                            placeholder="Ex: 10"
                                                            value={nouveauDiscount}
                                                            onChange={(e) => setNouveauDiscount(e.target.value)}
                                                            size="sm"
                                                            className="flex-grow-1"
                                                            style={{ height: 'calc(1.5em + 0.75rem + 2px)' }}
                                                        />
                                                        <span className="ml-2 text-muted">%</span>
                                                    </div>
                                                    <small className="text-muted">
                                                        Actuel : {selectedInscription?.discount || '0'}%
                                                    </small>
                                                </div>

                                                <div className="text-right mt-3">
                                                    <Button
                                                        variant="success"
                                                        onClick={handleSaveInscription}
                                                        disabled={isLoadingModif}
                                                        size="sm"
                                                    >
                                                        {isLoadingModif ? 'Chargement...' : 'Enregistrer'}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Colonne 3: Notes - Hauteur variable selon les commentaires */}

                                    <div className="col-md-4">
                                        <div className="card" style={{ height: '100%' }}>
                                            <div className="card-header bg-light">
                                                <strong>Notes</strong>
                                            </div>
                                            <div className="card-body p-0 d-flex flex-column">
                                                {/* En-tête avec nombre de commentaires et filtre */}
                                                <div className="border-bottom p-3" style={{ flexShrink: 0 }}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <strong className="small">Historique des notes</strong>
                                                        <div className="d-flex align-items-center">
                                                            <span className="badge bg-success me-2">
                                                                {filteredComments.length}
                                                            </span>

                                                            {/* Menu déroulant pour le filtre */}
                                                            <Dropdown>
                                                                <Dropdown.Toggle
                                                                    variant="light"
                                                                    size="sm"
                                                                    className="py-1 px-2"
                                                                    style={{ fontSize: '0.8rem' }}
                                                                >
                                                                    {getFilterLabel()}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        onClick={() => setCommentFilter('tous')}
                                                                        className="d-flex justify-content-between align-items-center"
                                                                    >
                                                                        <span>Tous</span>
                                                                        {commentFilter === 'tous' && <FaCheck size={12} />}
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={() => setCommentFilter('systeme')}
                                                                        className="d-flex justify-content-between align-items-center"
                                                                    >
                                                                        <span>Système</span>
                                                                        {commentFilter === 'systeme' && <FaCheck size={12} />}
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={() => setCommentFilter('commercial')}
                                                                        className="d-flex justify-content-between align-items-center"
                                                                    >
                                                                        <span>Commercial</span>
                                                                        {commentFilter === 'commercial' && <FaCheck size={12} />}
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Liste des commentaires filtrés */}
                                                <div className="flex-grow-1" style={{
                                                    overflowY: 'auto',
                                                    height: '300px',
                                                    maxHeight: '300px'
                                                }}>
                                                    {filteredComments.length > 0 ? (
                                                        <div>
                                                            {/* Regrouper les commentaires par date (plus récent en premier) */}
                                                            {Object.entries(
                                                                filteredComments.reduce((groups, comment) => {
                                                                    // Formater la date en français (ex: "15 janvier 2024")
                                                                    const dateKey = new Date(comment.date).toLocaleDateString('fr-FR', {
                                                                        day: 'numeric',
                                                                        month: 'long',
                                                                        year: 'numeric'
                                                                    });

                                                                    if (!groups[dateKey]) groups[dateKey] = [];
                                                                    groups[dateKey].push(comment);
                                                                    return groups;
                                                                }, {})
                                                            )
                                                                .sort((a, b) => new Date(b[0]) - new Date(a[0])) // Tri des dates (plus récent en premier)
                                                                .map(([date, commentsForDate]) => (
                                                                    <div key={date} className="px-3 pt-3">
                                                                        {/* Date au-dessus du groupe */}
                                                                        <div className="mb-3">
                                                                            <div className="text-center">
                                                                                <span style={{
                                                                                    display: 'inline-block',
                                                                                    backgroundColor: '#f8f9fa',
                                                                                    padding: '4px 12px',
                                                                                    borderRadius: '20px',
                                                                                    fontSize: '0.8rem',
                                                                                    fontWeight: '600',
                                                                                    color: '#495057',
                                                                                    border: '1px solid #e9ecef'
                                                                                }}>
                                                                                    {date}
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                        {/* Notes pour cette date (plus récent en haut) */}
                                                                        {commentsForDate
                                                                            .sort((a, b) => new Date(b.date) - new Date(a.date)) // Tri des commentaires (plus récent en premier)
                                                                            .map((comment) => {
                                                                                // Extraire l'heure du commentaire
                                                                                const commentDate = new Date(comment.date);
                                                                                const formattedTime = commentDate.toLocaleTimeString('fr-FR', {
                                                                                    hour: '2-digit',
                                                                                    minute: '2-digit'
                                                                                });

                                                                                return (
                                                                                    <div key={comment.id} className="mb-3">
                                                                                        {/* Carte de note */}
                                                                                        <div className="border rounded p-3 position-relative"
                                                                                            style={{
                                                                                                backgroundColor: isSystemComment(comment.auteur) ? '#f0f8ff' : '#ffffff',
                                                                                                borderColor: isSystemComment(comment.auteur) ? '#cce5ff' : '#dee2e6'
                                                                                            }}>

                                                                                            {/* En-tête avec auteur */}
                                                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                                <div className="d-flex align-items-center">
                                                                                                    {/* Icône utilisateur au lieu d'avatar */}
                                                                                                    <div className="mr-2" style={{
                                                                                                        width: '32px',
                                                                                                        height: '32px',
                                                                                                        borderRadius: '50%',
                                                                                                        backgroundColor: isSystemComment(comment.auteur) ? '#007bff' : '#28a745',
                                                                                                        color: 'white',
                                                                                                        display: 'flex',
                                                                                                        alignItems: 'center',
                                                                                                        justifyContent: 'center'
                                                                                                    }}>
                                                                                                        {isSystemComment(comment.auteur) ? (
                                                                                                            <FaRobot size={16} />
                                                                                                        ) : (
                                                                                                            <FaUser size={16} />
                                                                                                        )}
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <div style={{
                                                                                                            fontSize: '0.9rem',
                                                                                                            fontWeight: '600',
                                                                                                            color: '#212529'
                                                                                                        }}>
                                                                                                            {comment.auteur}
                                                                                                        </div>
                                                                                                        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                                                                                                            {formattedTime}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* Contenu de la note */}
                                                                                            <div className="mb-2">
                                                                                                <div className="small" style={{
                                                                                                    color: '#495057',
                                                                                                    lineHeight: '1.5'
                                                                                                }}>
                                                                                                    {comment.texte.includes('<') ? (
                                                                                                        <div dangerouslySetInnerHTML={{ __html: formatDateFr(comment.texte) }} />
                                                                                                    ) : (
                                                                                                        <div>{formatDateFr(comment.texte)}</div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* Badge système si applicable */}
                                                                                            {/* {isSystemComment(comment.auteur) && (
                                                <div className="text-right">
                                                    <small className="badge badge-info px-2 py-1" style={{
                                                        fontSize: '0.75rem',
                                                        backgroundColor: '#007bff',
                                                        color: 'white'
                                                    }}>
                                                        Système
                                                    </small>
                                                </div>
                                            )} */}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        }
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    ) : (
                                                        <div className="h-100 d-flex flex-column justify-content-center align-items-center p-4">
                                                            <FaComment size={32} className="text-muted mb-2" />
                                                            <p className="text-muted small mb-1">Aucun commentaire</p>
                                                            <small className="text-muted">
                                                                {commentFilter === 'tous'
                                                                    ? 'Ajoutez le premier commentaire'
                                                                    : `Aucun commentaire ${commentFilter === 'systeme' ? 'du système' : 'commercial'}`
                                                                }
                                                            </small>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Formulaire d'ajout de commentaire */}
                                                <div className="border-top p-3" style={{ flexShrink: 0 }}>
                                                    <Form.Group>
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <Form.Label className="small mb-0">
                                                                <strong>Ajouter une note:</strong>
                                                            </Form.Label>
                                                        </div>
                                                        <div className="mb-2">
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={3}
                                                                placeholder="Saisissez votre commentaire..."
                                                                value={newComment}
                                                                onChange={(e) => setNewComment(e.target.value)}
                                                                size="sm"
                                                                style={{ resize: 'vertical' }}
                                                            />
                                                        </div>
                                                        <div className="d-flex justify-content-end">
                                                            <Button
                                                                variant="success"
                                                                size="sm"
                                                                onClick={handleAddComment}
                                                                disabled={!newComment.trim() || isLoadingCommentaire}
                                                            >
                                                                <FaPlus className="mr-1" size={12} />
                                                                {isLoadingCommentaire ? '...' : 'Ajouter'}
                                                            </Button>
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
                                Fermer
                            </Button>
                        </Modal.Footer>
                    </Modal>


                    <Modal show={showArchiveModal} onHide={() => setShowArchiveModal(false)} centered>
                        <Modal.Header>
                            <Modal.Title>
                                <FaSyncAlt className="mr-2" />
                                Confirmer l'archivage
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedInscription && (
                                <>
                                    <p>
                                        Êtes-vous sûr de vouloir archiver l'inscription de :
                                    </p>
                                    <div className="alert alert-light border">
                                        <strong>{selectedInscription.prenoms} {selectedInscription.nom}</strong><br />
                                        <small>Email: {selectedInscription.email}</small><br />
                                        <small>Téléphone: {selectedInscription.telephone}</small><br />
                                        <small>Étape actuelle: <span>
                                            {selectedInscription.etape}
                                        </span></small>
                                    </div>
                                    <p className="text-muted small mb-0">
                                        <FaExclamationCircle className="text-success mr-1" />
                                        L'inscription sera déplacée dans les archives. Vous pourrez la désarchiver ultérieurement.
                                    </p>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowArchiveModal(false)}>
                                Annuler
                            </Button>
                            <Button
                                variant="success"
                                onClick={handleArchiveInscription}
                                disabled={isArchiving}
                            >
                                {isArchiving ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                        Archivage...
                                    </>
                                ) : (
                                    'Confirmer l\'archivage'
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>


                    <Modal show={showDeleteAcompteModal} onHide={() => setShowDeleteAcompteModal(false)} centered>
                        <Modal.Header>
                            <Modal.Title>
                                <FaTrash className="mr-2" />
                                Confirmer la suppression
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedAcompte && (
                                <>
                                    <p className="mb-3">
                                        Êtes-vous sûr de vouloir supprimer cet acompte ?
                                    </p>
                                    <div className="alert alert-secondary border">
                                        <div className="d-flex justify-content-between mb-2">
                                            <strong>Date :</strong>
                                            <span>{new Date(selectedAcompte.date).toLocaleDateString('fr-FR')}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <strong>Type :</strong>
                                            <span className={`badge ${selectedAcompte.type === 'Acompte' ? 'badge-info' : 'badge-success'}`}>
                                                {selectedAcompte.type}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>Montant :</strong>
                                            <span className="fw-bold">{selectedAcompte.montant} FCFA</span>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowDeleteAcompteModal(false)}>
                                Annuler
                            </Button>
                            <Button
                                variant="success"
                                onClick={handleDeleteAcompte}
                                disabled={isDeletingAcompte}
                            >
                                {isDeletingAcompte ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                        Suppression...
                                    </>
                                ) : (
                                    'Confirmer la suppression'
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>

            <style jsx>{`
                .cursor-pointer {
                    cursor: pointer;
                }
                .table tbody tr:hover {
                    background-color: #f8f9fa;
                }
                .badge {
                    font-size: 0.85em;
                    padding: 0.35em 0.65em;
                }
                .form-check-input:checked {
                    background-color: #0d6efd;
                    border-color: #0d6efd;
                }
                .card {
                    border: 1px solid #dee2e6;
                    border-radius: 0.375rem;
                }
                .card-header {
                    border-bottom: 1px solid #dee2e6;
                }
                .list-group-item {
                    border-left: 0;
                    border-right: 0;
                }
                .list-group-item:first-child {
                    border-top: 0;
                }
                .vr {
                    opacity: 0.3;
                }
            `}</style>
        </div>
    );
};

export default ListeInscriptions;